/* Season sale: shows the chosen Gym Monster 3 package's free kit above the price.
   The kit comes from the native accessory rows that gm3-addons marks data-state="free";
   those rows are never offered for sale in the cards or the add-to-cart pop-up.
   Every store: the number is the package's free value (kit plus Premium Care), with the two parts
   under it. AU, EU and UK add the machine saving as a first part. Where the page supplies the "up_to" and
   "with_pkg" words, the machine's biggest kit is always listed: the chosen package's items as free, the rest
   greyed with the smallest package that includes them, and one line under the figures names the biggest value.
   Every figure follows the VAT switch (SPXVat.applyRate) the way the package price does. */
(() => {
  'use strict';
  const native = document.querySelector('#gm2-addons-root[data-ebf-kit]');
  if (!native || native.dataset.ebfKitReady) return;
  native.dataset.ebfKitReady = 'true';
  let copy = {};
  try { copy = JSON.parse(native.getAttribute('data-ebf-copy') || '{}'); } catch (e) { return; }
  let map = {};
  try { map = JSON.parse(native.getAttribute('data-variant-savings') || '{}'); } catch (e) {}
  const careCents = parseInt(copy.care_cents, 10) || 0;
  const au = copy.au === true;
  const host = native.closest('bm-gm3-configurator') || document.querySelector('bm-gm3-configurator');
  const fill = (tpl, v) => (tpl || '').replace('{v}', v);
  const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = (cents) => {
    if (host && typeof host.extraMoney === 'function') {
      try { return String(host.extraMoney(cents)).replace(/[.,]00(?=\D*$)/, ''); } catch (e) {}
    }
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return String(Math.round(cents / 100)); }
  };
  /* One currency style on every surface: the figure without a region prefix, and the code
     (AUD, NZD) as a small muted tag after the big number, as on the homepage band. */
  /* Cents the shopper sees: ex-VAT cents in, displayed cents out, so the panel follows the Excl/Incl VAT
     switch exactly as the package price and the other widgets do. Switzerland and stores without the
     VAT engine are left as they are. */
  const disp = (cents) => {
    const v = window.SPXVat;
    if (!v || typeof v.applyRate !== 'function' || v.country === 'CH') return Math.round(cents);
    return v.applyRate(cents);
  };
  const bare = (shown) => money(shown).replace(/^[A-Za-z]{1,3}(?=\$)/, '');
  const activeCode = ((window.Shopify && Shopify.currency && Shopify.currency.active) || '').toUpperCase();
  const codeTag = activeCode === 'AUD' || activeCode === 'NZD' ? '<span class="bm-ebf-kit__code">' + activeCode + '</span>' : '';
  const currentId = () => {
    const fromHost = host && host.getAttribute('data-selected-variant-id');
    if (fromHost) return fromHost;
    const field = document.querySelector('product-form form [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return field ? field.value : '';
  };
  const packageName = () => {
    const d = map[currentId()];
    const t = d && d.title && d.title !== 'Default Title' ? d.title : '';
    return t.split('/').map((x) => x.trim()).filter(Boolean).join(' ');
  };
  const machineSaving = () => {
    const d = map[currentId()];
    const diff = d ? (parseInt(d.compare, 10) || 0) - (parseInt(d.price, 10) || 0) : 0;
    return diff > 0 ? diff : 0;
  };
  const box = document.createElement('section');
  box.className = 'bm-ebf-kit';
  box.setAttribute('data-bm-ebf-kit', '');
  const mount = () => {
    if (box.isConnected) return true;
    const scope = host || document;
    const anchor = scope.querySelector('.bmc-price-caption') || scope.querySelector('.bmc-price-row') || scope.querySelector('.bmc-purchase') || scope.querySelector('product-form');
    if (!anchor || !anchor.parentNode) return false;
    anchor.parentNode.insertBefore(box, anchor);
    return true;
  };
  /* Stars and the what-it-does line come from the add-to-cart pop-up script, so both surfaces use one rule
     and one set of translated lines. Without it the rows render with neither. */
  const offerApi = () => window.BMAccessoryOffer || {};
  const star = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 1.5l2.6 5.6 6.1.7-4.5 4.2 1.2 6.1L10 15l-5.4 3.1 1.2-6.1L1.3 7.8l6.1-.7z"/></svg>';
  const ratingHtml = (row) => {
    const api = offerApi();
    const r = typeof api.rating === 'function' ? api.rating(row) : null;
    if (!r) return '';
    const loc = document.documentElement.lang || 'en';
    const label = typeof api.ratingLabel === 'function' ? api.ratingLabel(r) : '';
    return '<span class="bm-ebf-kit__rating" role="img"' + (label ? ' aria-label="' + esc(label) + '"' : '') + '>' +
      '<span class="bm-ebf-kit__stars">' + star.repeat(5) + '<span class="bm-ebf-kit__stars-fill" style="width:' + (r.avg / 5 * 100) + '%">' + star.repeat(5) + '</span></span>' +
      '<span class="bm-ebf-kit__ravg">' + esc(r.avg.toLocaleString(loc, { minimumFractionDigits: 1, maximumFractionDigits: 1 })) + '</span>' +
      '<span class="bm-ebf-kit__rcount">(' + esc(r.count.toLocaleString(loc)) + ')</span></span>';
  };
  const doesHtml = (row) => {
    const api = offerApi();
    const text = (typeof api.does === 'function' ? api.does(row.getAttribute('data-handle') || '') : '') || row.getAttribute('data-ax-benefit') || '';
    return text ? '<span class="bm-ebf-kit__does">' + esc(text) + '</span>' : '';
  };
  const ledgerRow = (shown, text) => '<li><span class="bm-ebf-kit__lval">' + esc(bare(shown)) + '</span><span class="bm-ebf-kit__ltxt">' + esc(text) + '</span></li>';
  /* Package words come from the product's own variant titles, so "Station" and "Studio" read as the shopper sees them. */
  const TIERS = ['core', 'studio', 'station'];
  const parseTitle = (t) => {
    const title = String(t || '');
    const m = /station|studio|core/i.exec(title);
    return { model: /3S/i.test(title) ? 'gm3s' : 'gm3', tier: m ? m[0].toLowerCase() : '', word: m ? m[0] : '' };
  };
  let kitMap = {};
  try { kitMap = JSON.parse(native.getAttribute('data-ebf-kit') || '{}'); } catch (e) {}
  const full = !!copy.with_pkg && !!Object.keys(kitMap).length;
  const variantFor = (model, tier) => {
    const id = Object.keys(map).find((k) => { const p = parseTitle(map[k].title); return p.model === model && p.tier === tier; });
    return id ? map[id] : null;
  };
  const wordFor = (model, tier) => { const d = variantFor(model, tier); return d ? parseTitle(d.title).word : tier.charAt(0).toUpperCase() + tier.slice(1); };
  const rowFor = (handle) => native.querySelector('.gm2ax__row[data-handle="' + handle + '"]');
  const stockOf = (r) => {
    /* "later" (selling on from incoming stock) wins over the row's own sold-out flag,
       which treats zero stock as unavailable even when the variant keeps selling. */
    const ebfStock = r.getAttribute('data-ebf-stock') || 'in';
    return ebfStock === 'later' ? 'later' : (ebfStock === 'out' || r.getAttribute('data-catalog-available') === 'false' ? 'out' : 'in');
  };
  const itemHtml = (r, off) => {
    const price = parseInt(r.getAttribute('data-price'), 10) || 0;
    const name = (r.querySelector('.gm2ax__name') && r.querySelector('.gm2ax__name').firstChild && r.querySelector('.gm2ax__name').firstChild.textContent.trim()) || r.getAttribute('data-handle');
    const img = r.querySelector('.gm2ax__img img');
    const stock = stockOf(r);
    const value = bare(disp(price));
    const note = !off && stock === 'later' ? copy.later : '';
    const stars = ratingHtml(r);
    const tag = off
      ? '<span class="bm-ebf-kit__with">' + esc(fill(copy.with_pkg, off)) + '</span>'
      : '<span class="bm-ebf-kit__free">' + esc(stock === 'out' ? copy.out : copy.free) + '</span>';
    return '<li class="bm-ebf-kit__item' + (stars ? '' : ' bm-ebf-kit__item--plain') + (off ? ' bm-ebf-kit__item--off' : '') + '" data-stock="' + (off ? 'in' : stock) + '">' +
      '<span class="bm-ebf-kit__img">' + (img ? '<img src="' + esc(img.getAttribute('src')) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
      '<span class="bm-ebf-kit__name">' + esc(name) + '</span>' +
      '<span class="bm-ebf-kit__price">' + (!off && stock === 'out' ? '' : '<s>' + esc(value) + '</s>') + tag + '</span>' +
      stars + doesHtml(r) +
      (note ? '<span class="bm-ebf-kit__note">' + esc(note) + '</span>' : '') + '</li>';
  };
  const render = () => {
    const rank = (r) => { const n = parseInt(r.style.order, 10); return isNaN(n) ? 0 : n; };
    const rows = [].slice.call(native.querySelectorAll('.gm2ax__row[data-handle][data-state="free"]'))
      .map((r, i) => ({ r, i })).sort((a, b) => rank(a.r) - rank(b.r) || a.i - b.i).map((x) => x.r);
    if (!rows.length) { box.hidden = true; return; }
    let kitSum = 0;
    rows.forEach((r) => { if (stockOf(r) !== 'out') kitSum += parseInt(r.getAttribute('data-price'), 10) || 0; });
    let items = rows.map((r) => itemHtml(r, '')).join('');
    const pkg = packageName();
    const saving = au ? machineSaving() : 0;
    /* The big number is the chosen package's value, built from the figures the shopper sees so the rows add up. */
    const dSave = disp(saving), dKit = disp(kitSum), dCare = disp(careCents);
    const total = dSave + dKit + dCare;
    let ledger = '';
    if (saving > 0) ledger += ledgerRow(dSave, copy.stack_machine);
    if (kitSum > 0) ledger += ledgerRow(dKit, copy.stack_kit);
    if (careCents > 0) ledger += ledgerRow(dCare, copy.stack_care);
    let upTo = '';
    if (full) {
      const cur = parseTitle((map[currentId()] || {}).title);
      const chosen = kitMap[cur.model + '-' + cur.tier] || [];
      const tierKits = TIERS.filter((t) => kitMap[cur.model + '-' + t]);
      const bigTier = tierKits.slice().sort((a, b) => kitMap[cur.model + '-' + b].length - kitMap[cur.model + '-' + a].length || TIERS.indexOf(a) - TIERS.indexOf(b))[0];
      if (bigTier) {
        const bigList = kitMap[cur.model + '-' + bigTier];
        const greyed = bigList.filter((h) => chosen.indexOf(h) < 0).map((h) => {
          const r = rowFor(h);
          if (!r) return '';
          const first = tierKits.find((t) => kitMap[cur.model + '-' + t].indexOf(h) > -1);
          return itemHtml(r, wordFor(cur.model, first || bigTier));
        }).join('');
        items += greyed;
        if (cur.tier && cur.tier !== bigTier) {
          let bigKit = 0;
          bigList.forEach((h) => { const r = rowFor(h); if (r && stockOf(r) !== 'out') bigKit += parseInt(r.getAttribute('data-price'), 10) || 0; });
          const bv = variantFor(cur.model, bigTier);
          const bigSave = au && bv ? Math.max(0, (parseInt(bv.compare, 10) || 0) - (parseInt(bv.price, 10) || 0)) : 0;
          const bigTotal = disp(bigSave) + disp(bigKit) + disp(careCents);
          if (bigTotal > total) {
            upTo = '<p class="bm-ebf-kit__upto">' + esc(copy.up_to || '').replace('{v}', '<b>' + esc(bare(bigTotal)) + '</b>').replace('{p}', esc(wordFor(cur.model, bigTier))) + '</p>';
          }
        }
      }
    }
    const head =
      '<p class="bm-ebf-kit__title">' + esc(fill(au ? copy.label_au : copy.title, pkg || copy.machine || '')) + '</p>' +
      '<p class="bm-ebf-kit__number">' + esc(bare(total)) + '<span class="bm-ebf-kit__star">*</span>' + codeTag + '</p>' +
      '<ul class="bm-ebf-kit__ledger">' + ledger + '</ul>' + upTo;
    box.innerHTML =
      '<p class="bm-ebf-kit__phase">' + esc(copy.phase) + '</p>' + head +
      '<ul class="bm-ebf-kit__list">' + items + '</ul>' +
      '<p class="bm-ebf-kit__stock">' + esc(copy.note) + '</p>';
    box.hidden = false;
  };
  let frame = 0;
  const queue = () => { if (!frame) frame = requestAnimationFrame(() => { frame = 0; mount(); render(); }); };
  queue();
  document.addEventListener('bm:accessory-offer:ready', queue);
  document.addEventListener('spx:vat:change', queue);
  document.addEventListener('spx:vat:ready', queue);
  new MutationObserver(queue).observe(native, { subtree: true, attributes: true, attributeFilter: ['data-state'] });
  if (host) new MutationObserver(queue).observe(host, { attributes: true, attributeFilter: ['data-selected-variant-id'] });
  document.addEventListener('change', (e) => { if (e.target && e.target.matches && e.target.matches('input[type="radio"], select, [name="id"]')) setTimeout(queue, 60); });
  let tries = 0;
  const wait = setInterval(() => { if (mount() || ++tries > 40) { clearInterval(wait); queue(); } }, 250);
})();
